import React, { useState } from "react";
import { EXECUTION_LOGS_STATUS_OPTIONS } from "../utils/constants";
import CheckIcon from "../../../assets/svg/check-icon";
import Button from "../../Button/Button";
import {
  FilterState,
  selectCampaignExecutionLogsFilters,
  setCampaignExecutionLogsStatus,
} from "../../../redux/slices/filterSlice";
import { useDispatch, useSelector } from "react-redux";

interface ExecutionLogsStatusFilterProps {
  onClose: () => void;
}

const ExecutionLogsStatusFilter: React.FC<ExecutionLogsStatusFilterProps> = ({
  onClose,
}) => {
  const campaignExecutionLogsStatus = useSelector(
    (state: { filter: FilterState }) =>
      selectCampaignExecutionLogsFilters(state)?.status
  );
  const [selectedStatus, setSelectedStatus] = useState<{
    value: string;
    displayValue: string;
  } | null>({
    value: campaignExecutionLogsStatus?.value as string,
    displayValue: campaignExecutionLogsStatus?.displayValue as string,
  });
  const dispatch = useDispatch();

  const handleStatusSelect = (status: string) => {
    const statusOption = EXECUTION_LOGS_STATUS_OPTIONS.find(
      (option) => option.value === status
    );
    if (statusOption) {
      setSelectedStatus((prev) =>
        prev?.value === status
          ? null
          : { value: status, displayValue: statusOption.content }
      );
    }
  };

  const handleApply = () => {
    if (selectedStatus) {
      dispatch(
        setCampaignExecutionLogsStatus({
          value: selectedStatus.value,
          displayValue: selectedStatus.displayValue,
        })
      );
    }
    onClose();
  };

  return (
    <div className="flex flex-col">
      {/* Selected Status Display */}
      {selectedStatus && (
        <div className="flex items-center justify-between p-3 bg-verba-blue-light-card-bg dark:bg-verba-blue-light-card-bg-dk border-b border-border-gray dark:border-border-gray-dk">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
              {selectedStatus?.displayValue}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <CheckIcon className="w-4 h-4 text-verba-blue dark:text-verba-blue-dk" />
          </div>
        </div>
      )}

      {/* Status List */}
      <div className="flex flex-col max-h-[600px] ">
        <div className="px-3 py-2 text-xs font-semibold text-dark-gray dark:text-dark-gray-dk uppercase border-b border-border-gray dark:border-border-gray-dk">
          All Statuses
        </div>

        <div className="overflow-y-auto">
          {EXECUTION_LOGS_STATUS_OPTIONS.filter(
            (status) => status.value !== selectedStatus?.value
          ).map((status) => (
            <div
              key={status.value}
              onClick={() => handleStatusSelect(status.value)}
              className="flex items-center justify-between p-3 cursor-pointer hover:bg-hover-gray dark:hover:bg-hover-gray-dk border-b border-border-gray dark:border-border-gray-dk last:border-b-0"
            >
              <div className="flex-1 min-w-0">
                <div className="text-md text-heading-text dark:text-heading-text-dk truncate">
                  {status.content}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end gap-2 mt-4 px-3 pb-2">
        <Button
          innerText="Cancel"
          buttonContainerClass="py-1 px-7.5 border border-verba-indigo dark:border-verba-indigo-dk rounded-lg"
          innerTextClass="text-md font-medium whitespace-nowrap text-heading-text dark:text-heading-text-dk"
          onClick={onClose}
        />
        <Button
          innerText="Apply"
          buttonContainerClass="py-1 px-7.5 rounded-lg bg-verba-indigo dark:bg-verba-indigo-dk"
          innerTextClass="text-md font-medium whitespace-nowrap text-pure-white dark:text-pure-white-dk"
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default ExecutionLogsStatusFilter;
